<template>
  <div class="row">
    <div class="col-12">
      <div class="new-button-div">
        <!-- Botón Nuevo -->
          <router-link :to="{ name: 'Nuevo Rol' }" class="col-2">
            <n-button type="primary" round>
              <i slot="label" class="now-ui-icons ui-1_simple-add"></i>

              {{ $t("app.buttons.new") }}
            </n-button>
            </router-link>
      </div>
      <card card-body-classes="table-full-width" no-footer-line>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.roles.title") }}
            </h4>
            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>
          <el-table stripe style="width: 100%;" :data="queriedData">
             <el-table-column
              :label="$t('app.modules.roles.headers.identifier')"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.id }}
              </template>
            </el-table-column>

             <el-table-column
              :label="$t('app.modules.roles.headers.name')"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.nombre }}
              </template>
            </el-table-column>

             <el-table-column
              :label="$t('app.modules.roles.headers.description')"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.descripcion }}
              </template>
            </el-table-column>

             <el-table-column
              :label="$t('app.general.state')"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.activo_str }}
              </template>
            </el-table-column>

             <el-table-column
              :label="$t('app.modules.roles.headers.resgistration_date')"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.concurrencyStamp }}
              </template>
            </el-table-column>

             <el-table-column
              :min-width="200"
              fixed="right"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          EditItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.corporate_roles.edit") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>

            <!--
            <el-table-column :min-width="135" fixed="right" label="Acciones">
              <div slot-scope="props" class="table-actions dropdown">
                <n-button
                  @click.native="EditItem(props.$index, props.row)"
                  class="like"
                  type="info"
                  size="md"
                  round
                  icon
                >
                  <i class="fa fa-pencil"></i>
                </n-button>
              </div>
            </el-table-column>
            -->
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>

    </div>
  </div>
</template>
<script>
import Fuse from "fuse.js";

export default {
  components: {

  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      result =
        this.searchQuery.length > 0
          ? result.filter(p => p.nombre.toLowerCase().includes(this.searchQuery.toLowerCase()))
          : result;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      type: ["", "info", "success", "warning", "danger"],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["name", "empresa"],
      tableColumns: [
        {
          prop: "id",
          label: this.$t("app.modules.roles.headers.identifier"),
          minWidth: 120, 
          sortable: true 
        },
        {
          prop: "nombre",
          label: this.$t("app.modules.roles.headers.name"),
          minWidth: 200
        },
        {
          prop: "descripcion",
          label: this.$t("app.modules.roles.headers.description"),
          minWidth: 150
        },
        {
          prop: "activo_str",
          label: this.$t("app.general.state"),
          minWidth: 100
        },
        {
          prop: "concurrencyStamp",
          label: this.$t("app.modules.roles.headers.resgistration_date"),
          minWidth: 200
        }
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    async initPerfiles() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };
      await this.$http
        .post(route("Roles/rolesVista"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.tableData = response.body.roles.filter(r => !r.externo);
              for (let rol of this.tableData) {
                if (rol.active) {
                  rol.activo_str = this.$t(
                    "app.modules.roles.headers.status_active"
                  );
                } else {
                  rol.activo_str = this.$t(
                    "app.modules.roles.headers.status_inactive"
                  );
                }
              }
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    },
    EditItem(index, row, ref) {
      this.$router.push({ name: 'Editar rol', params: row })
      this.$refs[ref].doClose();
    },
    handleDelete(index, row) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteRow(row);
            Swal.fire({
              title: "Deleted!",
              text: `You deleted ${row.name}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          }
        });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "empresa"],
      threshold: 0.3
    });
    this.initPerfiles();

    EventBus.$on("reload-items-perfiles", () => {
      this.initPerfiles();
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    
  }
};
</script>
<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
</style>
